import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import brief_error_icon from '../../assets/brief_error.svg';

export const ErrorIcon = () => (
  <Container
    flexShrink="0"
    width={152}
    height={129}
    style={{
      backgroundImage: `url(${brief_error_icon})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }}
  />
);
